export default __webpack_public_path__ + "static/media/product_3.1.9c207cdf.jpg";